import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../services/global.service';

@Component({
  selector: 'app-applications',
  templateUrl: './applications.component.html',
  styleUrls: ['./applications.component.css']
})
export class ApplicationsComponent implements OnInit {

  public isS: boolean;
  public isA: boolean;
  public isNW: boolean;

  constructor(private globalService:GlobalService) {}

  ngOnInit() {
    this.isS = (Number(localStorage.getItem('orgID')) === 371 || Number(localStorage.getItem('parentID')) === 371) ? true : false;
    this.isA = (Number(localStorage.getItem('orgID')) === 421 || Number(localStorage.getItem('parentID')) === 421) ? true : false;
    
    this.isNW = (Number(localStorage.getItem('orgID')) === 239 || Number(localStorage.getItem('parentID')) === 239) ? true : false;

    this.globalService.featMeansTesting = JSON.parse(localStorage.getItem('featMeansTesting'));
    this.globalService.featLongTermCare = JSON.parse(localStorage.getItem('featLongTermCare'));
    this.globalService.featSocialSecurity = JSON.parse(localStorage.getItem('featSocialSecurity'));
    this.globalService.featHealthCare = JSON.parse(localStorage.getItem('featHealthCare'));
  }

  handlePopup(app, w, h) {
    var winFeature =
        'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,' + 'width=' + w + ', height=' + h;

    if (app == 'HVSLTCMap') {
      window.open('https://la.hvsfinancial.com/Applications/' + app, 'window', winFeature);
    } else {
      window.open('https://la.hvsfinancial.com/tools/' + app, 'window', winFeature);
    }
  }

}
